import {
  StorageLimitedResourcesInfo,
  useGetSubscriptionIdQuery,
  useSubscriptionStorageSubscription,
} from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';

// There is a known limitation to the massdriver SubscriptionPublisher. When
// the DelinquencyRefreshWorker runs, it only checks for state transitions.
// Therefore if a usage change happens but delinquency doesn't change, then
// that change isn't published. E.g. Mounted Storage goes over the limit, but
// the account is already delinquent because Active Storage usage is over as well.
export function StorageEventsSubscription() {
  const accountId = useActiveAccountId();

  const { data: subscriptionIdData } = useGetSubscriptionIdQuery({
    variables: { accountId },
    skip: !accountId,
  });

  const accountSubscriptionId = subscriptionIdData?.account?.subscription?.id;

  useSubscriptionStorageSubscription({
    variables: { scope: { update: { accountSubscriptionId } } },
    skip: !accountSubscriptionId,
    onData: ({ client: { cache }, data: { data: result } }) => {
      const payload = result?.accountSubscription;
      if (payload?.__typename !== 'UpdateAccountSubscriptionPayload') return;

      cache.updateFragment(
        {
          id: cache.identify({
            __typename: 'AccountSubscription',
            id: accountSubscriptionId,
          }),
          fragment: StorageLimitedResourcesInfo,
          fragmentName: 'StorageLimitedResourcesInfo',
        },
        (prev) => ({
          ...prev,
          limitedResources: payload.accountSubscription?.limitedResources,
        })
      );
    },
  });

  return null;
}
